import { render, staticRenderFns } from "./carusel.vue?vue&type=template&id=6be45e38"
import script from "./carusel.vue?vue&type=script&lang=js"
export * from "./carusel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports